import React from 'react';
import { FormattedPlainText } from './FormattedPlainText';
import { SafeHtmlContent } from './SafeHtmlContent';
import { looksLikeHtml } from '../utils/richTextUtils';

const RICH_TEXT_CLASS =
  'text-gray-700 text-sm leading-relaxed ' +
  '[&_p]:mb-2 [&_p:last-child]:mb-0 ' +
  '[&_ol]:list-decimal [&_ol]:pl-5 [&_ol]:my-2 [&_ol]:space-y-1 ' +
  '[&_ul]:list-disc [&_ul]:pl-5 [&_ul]:my-2 [&_ul]:space-y-1 ' +
  '[&_li]:leading-snug ' +
  '[&_strong]:font-semibold [&_strong]:text-gray-800 ' +
  '[&_a]:text-blue-600 [&_a]:underline [&_a:hover]:text-blue-800';

/** Legacy plain text or rich-text HTML from the ticket editor. */
export function TicketDescriptionContent({ description }) {
  if (description == null || description === '') {
    return null;
  }

  if (looksLikeHtml(description)) {
    return <SafeHtmlContent className={RICH_TEXT_CLASS} html={description} />;
  }

  return (
    <FormattedPlainText
      text={description}
      className="text-gray-700 text-sm leading-relaxed whitespace-pre-wrap"
    />
  );
}
